import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/adidas-dtt-logo.svg'
import _imports_1 from '@/assets/hoc-teamportal-letterin-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-304fbd24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-logo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "adidas-logo-main" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "adidas-logo",
    class: "adidas-logo d-none d-lg-inline-block header-logo",
    src: _imports_0,
    width: "160",
    height: "52"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "teamportal-logo-main" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "teamportal-logo",
    class: "teamportal-logo d-none d-lg-inline-block header-logo",
    src: _imports_1,
    width: "400",
    height: "70"
  })
], -1))

import { computed, defineAsyncComponent, onMounted } from "vue"
import _ from "lodash"
import { router } from "@/router"
import { CONSTANT } from "@/helpers/constant"
import { getPageName, isCheckSalesRep, trackPageView } from "@/helpers/common"
import { useAuthStore, useCustomerStore } from "@/stores"
import { useTeamOrderStore } from "@/stores/teamOrder.store"
import { useSystemAndContextStore } from "@/stores/systemAndContext.store"


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const AppNavBar = defineAsyncComponent(() => import("@/components/AppNavBar/AppNavBar.vue"))
const AppContactInfo = defineAsyncComponent(() => import("@/components/AppContactInfo.vue"))

const systemAndContextStore = useSystemAndContextStore()
const teamOrderStore = useTeamOrderStore()
const customerStore = useCustomerStore()
const authStore = useAuthStore()

const isSalesRep = computed(() => isCheckSalesRep(customerStore.customer))

// Set up the Google Tag Manager script
const script = document.createElement("script")
script.async = true

onMounted(async () => {
  if (!isSalesRep.value) {
    if (_.isEmpty(systemAndContextStore.getCurrentContext)) {
      await systemAndContextStore.fetchCurrentContext()
    }
    const currentContext = systemAndContextStore.getCurrentContext
    const containerId = _.get(currentContext, "extensions.eecom_gtm_id.eecom_gtm_id", "")
    if (containerId) {
      script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`
      script.async = true
      document.head.appendChild(script)
      router.afterEach((to) => {
        // Set the dynamic page name based on your application's logic
        const pageName = getPageName(to)
        trackPageView(pageName, containerId)
      })
    }

    if (currentContext?.token) {
      await authStore.setContextToken(currentContext.token)
    }
    await teamOrderStore.checkoutCart()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: { name: _unref(CONSTANT).ROUTE.NAME.DASHBOARD_CUSTOMER },
        class: "nav-link user-select-none pe-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_unref(AppContactInfo), { "is-mobile": false })
    ]),
    _createVNode(_unref(AppNavBar))
  ]))
}
}

})